<script lang="ts">
  import ModalPartial from './ModalPartial.svelte';

  export let videoElement: HTMLElement;
  export let handleModalClose: () => void;
  export let modalPartialConfig: ModalPartialConfig;
  export let isModalOpen: boolean;
</script>

<ModalPartial on:closeModal={handleModalClose} modalPartialConfig={{ ...modalPartialConfig, active: isModalOpen }}>
  <div class="video-player" data-active={isModalOpen}>
    <div class="video-player-content">
      <div bind:this={videoElement} />
    </div>
  </div>
</ModalPartial>

<style lang="scss">
  @layer standard-components {
    :global(#videoPlayer .ModalPartial) {
      transition: opacity var(--duration-slow) var(--easing-decelerate);
      :global(.modal-scroll) {
        transition: opacity 3s;
        max-width: none;
      }
    }

    // video player root
    .video-player {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: black;

      .video-player-content {
        opacity: 0;
        visibility: hidden;
        height: 100%;
        width: 100%;
        padding: var(--space-60) 0;
      }

      //  active state
      &[data-active='true'] {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;

        .video-player-content {
          opacity: 1;
          visibility: visible;
        }
      }

      // Make fullscreen
      :global(iframe) {
        width: 100%;
        height: 100%;
      }
      :global(div) {
        width: 100%;
        height: 100%;
      }
      :global(video) {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>
